<template>
  <div class="app-container">
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="dialogAddEditViewFormRules"
        >
          <el-row :gutter="10">
            <el-col :span="3">
              <el-form-item
                label="省区"
                prop="provinceId"
              >
                <el-select
                  v-model="dialogAddEditViewForm.provinceId"
                  filterable
                  clearable
                  placeholder="请选择省区"
                  style="width:100%"
                  @change="changeProvinceFun"
                >
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.data"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item
                label="城市"
                prop="cityId"
              >
                <el-select
                  v-model="dialogAddEditViewForm.cityId"
                  filterable
                  clearable
                  placeholder="请选择城市"
                  style="width:100%"
                  @change="changeCityFun"
                >
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.data"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item
                label="维护人员"
                prop="manageUserId"
              >
                <el-select
                  v-model="dialogAddEditViewForm.manageUserId"
                  filterable
                  clearable
                  placeholder="请选择维护人员"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in userOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.data"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item
                label="年份"
                prop="year"
              >
                <el-select
                  v-model="dialogAddEditViewForm.year"
                  filterable
                  clearable
                  placeholder="请选择年份"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in yearOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.data"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item
                label="月份"
                prop="month"
              >
                <el-select
                  v-model="dialogAddEditViewForm.month"
                  filterable
                  clearable
                  placeholder="请选择年份"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in monthOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.data"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col style="width:60px;padding-left:10px;">
              <el-form-item label=" ">
                <el-button
                  type="primary"
                  @click="handleSave()"
                >
                  导出
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadUserSelectDataByRegionIdsApi } from '@/api/user'
import { loadStoreExportVisitPlanWorkTableApi } from '@/api/store'
export default {
  name: "ExportVisitPlanTable",
  data() {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [ { required: true, message: '请选择省区', trigger: 'change' }],
        cityId: [ { required: true, message: '请选择城市', trigger: 'change' }],
        manageUserId: [ { required: true, message: '请选择维护人员', trigger: 'change' }],
        year: [ { required: true, message: '请选择年份', trigger: 'change' }],
        month: [ { required: true, message: '请选择月份', trigger: 'change' }]
      },
      provinceOptions: [],
      cityOptions: [],
      userOptions: [],
      yearOptions: [],
      monthOptions: []
    }
  },
  created() {
    this.provinceOptions = []
    this.cityOptions = []
    this.userOptions = []
    this.dialogAddEditViewForm = {
      provinceId: '',
      cityId: '',
      manageUserId: '',
      year: '',
      month: ''
    }
    let currentDate = new Date()
    let currentYear = currentDate.getFullYear()
    this.yearOptions = [{label: (currentYear-1)+'年',data: (currentYear-1)}, {label: currentYear+'年',data: currentYear}, {label: (currentYear+1)+'年',data: (currentYear+1)}]
    this.dialogAddEditViewForm.year = currentYear
    this.monthOptions = []
    for(let i = 1; i <= 12; i++){
      this.monthOptions.push({ label: i + '月', data: i })
    }
    this.dialogAddEditViewForm.month = currentDate.getMonth()+1
    this.initProvinceSelectData()
  },
  methods: {
    // 初始省区下拉数据
    initProvinceSelectData(){
      loadAreaDataApi({ parentId: 1, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
        this.loading = false
      })
    },
    // 选择省区回调
    changeProvinceFun(val){
      this.cityOptions = []
      this.userOptions = []
      this.dialogAddEditViewForm.cityId = null
      this.dialogAddEditViewForm.manageUserId = null
      this.initCitySelectData(val)
    },
     // 初始城市下拉数据
    initCitySelectData(val){
      loadAreaDataApi({ parentId: val, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
     // 选择城市回调
    changeCityFun (val){
      this.userOptions = []
      this.dialogAddEditViewForm.manageUserId = null
      this.initUserSelectData(val)
    },
     // 初始用户下拉数据
    initUserSelectData(val){
      loadUserSelectDataByRegionIdsApi({ regionIds: val }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.userOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否导出走访维护计划表','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      loadStoreExportVisitPlanWorkTableApi(this.dialogAddEditViewForm).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
      this.$message({
        dangerouslyUseHTMLString: true,
        type: 'success',
        message: `<strong>${this.$t('operation.tips_export')}</strong>`,
        duration: 5000,
        offset: 80
      })
    }
  }
};
</script>
<style lang="scss" scoped>
</style>